import React, { useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function AddProcess() {
  const { country } = useParams();
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const editorRef = useRef(null);

  const applyFormat = (command) => {
    document.execCommand(command, false, null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const processCode = (editorRef.current?.innerHTML || "").trim();
    if (!title.trim() || !processCode) {
      alert("All fields are required!");
      return;
    }

    axios
      .post(
        `${BASE_URL}/addprocess`,
        { Country: country, Title: title.trim(), ProcessCode: processCode },
        {
          headers: {
            Authorization: apiKey,
            "Content-Type": "application/json",
          },
        }
      )
      .then(() => {
        navigate(`/countries/${country}/process`);
      })
      .catch((error) => console.log(error));
  };

  return (
    <div className="container">
      <h2>Add New Process</h2>
      <br />
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-sm-6">
            <input
              className="form-control"
              placeholder="Process Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-sm-12">
            <div className="mb-2">
              <button
                type="button"
                className="btn btn-sm btn-dark mx-1"
                onClick={() => applyFormat("bold")}
              >
                B
              </button>
              <button
                type="button"
                className="btn btn-sm btn-dark mx-1"
                onClick={() => applyFormat("italic")}
              >
                I
              </button>
              <button
                type="button"
                className="btn btn-sm btn-dark mx-1"
                onClick={() => applyFormat("underline")}
              >
                U
              </button>
            </div>
            <div
              ref={editorRef}
              contentEditable
              className="form-control"
              style={{
                color: "#000",
                height: "250px",
                border: "1px solid #ccc",
                padding: "10px",
                overflowY: "auto",
              }}
            ></div>
          </div>
        </div>
        <br />
        <button className="btn btn-primary">Add Process</button>
      </form>
    </div>
  );
}
